import React from "react";

interface BenefitComponentsProps {
    imageUrl: string;
    title: string;
}

const BenefitComponents: React.FC<BenefitComponentsProps> = ({ imageUrl, title }) => {
    return (
        <div className="flex flex-col items-center text-center flex-1 w-40 h-40 mt-2 md:mt-2 gap-2">
            <img src={imageUrl} alt={title} className="w-9 h-9 object-contain" />
            <h4 className="text-sm font-medium text-gray-800 flex items-center justify-center min-h-[40px] px-2 font-poppins">
                {title}
            </h4>
        </div>
    );
};

export default BenefitComponents;